// Import utilities
import { LoadingSpinner } from "@shared/components/LoadingSpinner";
import { tailwindConfig } from "../../../utils/Utils";
import { useAnalyticsData } from "../hooks/useAnalyticsData";
import BarChart01 from "./charts/BarChart01";
import theme from "@shared/utils/themeColors";

function CorrectVsIncorrectByMonth() {
  const { loading, error, analyticsData } = useAnalyticsData();

  if (loading) {
    return (
      <div className={`flex flex-col col-span-full sm:col-span-6 ${theme.bg.primary} shadow-sm rounded-xl p-5`}>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex flex-col col-span-full sm:col-span-6 ${theme.bg.primary} shadow-sm rounded-xl p-5`}>
        <p className={`text-center ${theme.text.error}`}>Error: {error}</p>
      </div>
    );
  }

  if (
    !analyticsData?.monthlyTotalPerformance ||
    analyticsData.monthlyTotalPerformance.length === 0
  ) {
    return (
      <div className={`flex flex-col col-span-full sm:col-span-6 ${theme.bg.primary} shadow-sm rounded-xl p-5`}>
        <p className={`text-center ${theme.text.muted}`}>No data available</p>
      </div>
    );
  }

  // Process monthly data
  const sortedData = [...analyticsData.monthlyTotalPerformance].sort((a, b) => {
    const dateA = new Date(a.year, a.month - 1);
    const dateB = new Date(b.year, b.month - 1);
    return dateA.getTime() - dateB.getTime();
  });

  const chartData = {
    labels: sortedData.map(
      (item) => `${item.year}-${String(item.month).padStart(2, "0")}`
    ),
    datasets: [
      // Green bars for correct answers
      {
        label: "Correct",
        data: sortedData.map((item) => item.correctAnswers),
        backgroundColor: tailwindConfig().theme.colors.green[500],
        hoverBackgroundColor: tailwindConfig().theme.colors.green[600],
        barPercentage: 0.7,
        categoryPercentage: 0.7,
        borderRadius: 4,
      },
      // Red bars for incorrect answers
      {
        label: "Incorrect",
        data: sortedData.map((item) => item.incorrectAnswers),
        backgroundColor: tailwindConfig().theme.colors.gray[500],
        hoverBackgroundColor: tailwindConfig().theme.colors.gray[600],
        barPercentage: 0.7,
        categoryPercentage: 0.7,
        borderRadius: 4,
      },
    ],
  };

  return (
    <div className={`flex flex-col col-span-full sm:col-span-6 ${theme.bg.primary} shadow-sm rounded-xl`}>
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className={`font-semibold ${theme.text.primary}`}>
          Correct vs Incorrect by Month
        </h2>
      </header>
      <BarChart01
        data={chartData}
        width={595}
        height={248}
        monthlyTotalPerformance={sortedData}
      />
    </div>
  );
}

export default CorrectVsIncorrectByMonth;
